import {Children, ReactElement, ReactNode, useState} from "react";
import styles from './index.module.scss';

export type CustomTabBarProps = {
	panes: ReactNode;
	onTabClick: (key: string, e: any) => void;
	activeKey: string;
	expandButtonText: string;
}

export const CustomTabBar = (
	{ panes, onTabClick, activeKey, expandButtonText }: CustomTabBarProps
) => {
	const [showAll, setShowAll] = useState(false);
	const elements = Children.toArray(panes).map((el) => el as ReactElement);
	const titles = elements.map((el, i) => {
		return (
			<div
				className={`${styles.title} ${activeKey === el.props.tabKey && styles.titleActive}`}
				key={i}
				onClick={(e) => {
					if (i === 0) {
						setShowAll(false);
					}
					onTabClick(el.props.tabKey, e);
				}}>
				{(elements.length === 2 && i === 1) ? (
					<>{expandButtonText}</>
				) : (
					<>{el.props.tab}</>
				)}
			</div>
		)
	}).filter((_, index) => {
		if (!showAll && elements.length > 2) {
			return index < 1;
		}
		return true;
	});
	return <>
		<div className={styles.titles}>
			{titles}
			{(!showAll && elements.length > 2) && (
				<div
					className={styles.title}
					onClick={(e) => {
						if (elements[1] !== undefined) {
							onTabClick(elements[1].props.tabKey, e);
						}
						setShowAll(!showAll)
					}}
				>
					{expandButtonText}
				</div>
			)}
		</div>
	</>
}

export default CustomTabBar
